import type { HTMLAttributes } from 'react';

// Divisore decorativo: 3px gradient ambra 0%-28% poi ink 28%-100%.
// Pattern visivo identitario di Audiq.
export function RuleBicolor({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={`audiq-rule-bicolor ${className ?? ''}`} {...rest} />;
}
